import { Grid, Text, Box } from '@simplywallst/ui-core';
import type { TextProps } from '@simplywallst/ui-core';
import { RiskReward } from './RiskReward';

type Severity = 'minor' | 'major' | 'none' | null;

interface Props {
  severity?: unknown;
  description: string;
  typography?: TextProps['typography'];
}

const isSeverityType = (value: unknown): value is Severity => {
  if (typeof value !== 'string' && value !== null) {
    return false;
  }
  return ['minor', 'major', 'none', null].includes(value);
};

export const RiskRewardStatement = ({
  description,
  severity = null,
  typography = 'small',
}: Props) => (
  <Grid templateColumns="24px auto" alignItems="start" gap="8px">
    <RiskReward severity={isSeverityType(severity) ? severity : null} />
    {description && (
      <Box marginBottom="x0_5" marginTop="x0_25">
        <Text typography={typography}>{description}</Text>
      </Box>
    )}
  </Grid>
);
